// extracted by mini-css-extract-plugin
export var csatScore = "_ii-5";
export var header = "_ii-1";
export var panelWrapper = "_ii-2";
export var postPreview = "_ii-3";
export var rightContent = "_ii-0";
export var wrappingText = "_ii-4";